import { render, staticRenderFns } from "./SectionDigitalGovernment.vue?vue&type=template&id=0163e9e9&scoped=true"
import script from "./SectionDigitalGovernment.vue?vue&type=script&lang=ts"
export * from "./SectionDigitalGovernment.vue?vue&type=script&lang=ts"
import style0 from "./SectionDigitalGovernment.vue?vue&type=style&index=0&id=0163e9e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163e9e9",
  null
  
)

export default component.exports